import { Duration, MaintenanceScheduleAttributes } from '@/types'
import { UpdateMaintenanceScheduleMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditMaintenanceSchedulesQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { useEffect, useState } from 'react'
import { DeleteDialog } from '../delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'
import { Button } from '../base/button'

type MaintenanceSchedule = EditMaintenanceSchedulesQuery['maintenanceSchedules']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
  } = useForm<
    UpdateMaintenanceScheduleMutation,
    MaintenanceScheduleAttributes,
    EditMaintenanceSchedulesQuery,
    MaintenanceSchedule
  >({
    id,
    initializer: ms => ({
      maintenanceTypeId: ms.maintenanceType.id || '',
      details: ms.details || '',
      repeatMultiplier: ms.repeatMultiplier || 0,
      repeatPeriod: ms.repeatPeriod || Duration.Day
    }),
    query: EditQuery,
    queryKey: 'maintenanceSchedules',
    mutation: UpdateMutation,
    resultKey: 'updateMaintenanceSchedule'
  })
  const [showDelete, setShowDelete] = useState(false)

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  const onDelete = () => {
    setShowDelete(false)
    onSuccess()
  }

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        <div className="grid grid-cols-3 gap-6">
          { formBuilder.buildField({ name: 'Maintenance type', field: 'maintenanceTypeId', type: 'maintenance-type' }) }
          { formBuilder.buildField({ name: 'Repeat multiplier', field: 'repeatMultiplier', type: 'integer' }) }
          { formBuilder.buildField({ name: 'Repeat period', field: 'repeatPeriod', type: 'multiplier-type' }) }
        </div>
        { formBuilder.buildField({ name: 'Details', field: 'details', type: 'text' }) }
        <div className="flex flex-row justify-between">
          <Button color="red" onClick={() => setShowDelete(true) }>Delete</Button>
          { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
        </div>
      </div>
      <DeleteDialog
        id={id}
        mutation={DeleteMutation}
        open={showDelete}
        refetchQueries={[TableQuery]}
        setOpen={setShowDelete}
        onSuccess={onDelete}
      />
    </>
  )
}
